import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/datavg/bamboo-agent-home-3/xml-data/build-dir/CPSDE-CPKUNB0-DOC/node_modules/css-loader/dist/runtime/api.js'
import '/datavg/bamboo-agent-home-3/xml-data/build-dir/CPSDE-CPKUNB0-DOC/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/datavg/bamboo-agent-home-3/xml-data/build-dir/CPSDE-CPKUNB0-DOC/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import customerPortal from '~root/src/components/CustomerPortal.vue?shadow'
window.customElements.define('customer-portal', wrap(Vue, customerPortal))